import { render, staticRenderFns } from "./tags_form.vue?vue&type=template&id=58610af8"
import script from "./tags_form.vue?vue&type=script&lang=js"
export * from "./tags_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports